/// <reference types="@angular/localize" />

import { AppModule } from "./app/app.module";
import { platformBrowser } from "@angular/platform-browser";

/*(Error as any).prepareStackTrace = (_: unknown, stack: unknown[] | undefined): unknown[] | undefined => {
    console.error("STACK TRACE:\n", stack?.join("\n"));
    return stack;
};*/

platformBrowser()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
